import { render, staticRenderFns } from "./Courses-content.vue?vue&type=template&id=f4048d0a&scoped=true"
import script from "./Courses-content.vue?vue&type=script&lang=js"
export * from "./Courses-content.vue?vue&type=script&lang=js"
import style0 from "./Courses-content.vue?vue&type=style&index=0&id=f4048d0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4048d0a",
  null
  
)

export default component.exports